import React from "react";
import blogs from "../../data/blogs";

const BlogList = () => {
  return (
    <section className="blog section" id="blog">
      <div className="container">
        <h2 className="section-title">Our Blog</h2>
        <p className="section-subtitle">
          Stay updated with the latest insights on AI and real estate
        </p>

        <div className="blog-posts">
          {blogs.map((blog) => (
            <div key={blog.id} className="blog-post">
              <div className="blog-content">
                <span className="blog-category">{blog.category}</span>
                <h3 className="blog-title">{blog.title}</h3>
                <p className="blog-excerpt">{blog.excerpt}</p>
                <div className="blog-meta">
                  <span>By {blog.author}</span>
                  <span>{blog.date}</span>
                </div>
                <a href={`/blog/${blog.id}`} className="btn-read-more">
                  Read More →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogList;
